// app/javascript/modules/admissoes/cnh.js

const CARGOS_QUE_EXIGEM_CNH = [
  'manobrista',
  'motorista',
  'tratorista',
]

function cargoExigeCnh(cargo) {
  if (!cargo) return false
  const lower = cargo.toLowerCase().trim()
  return CARGOS_QUE_EXIGEM_CNH.some((c) => lower.includes(c))
}

export function initCnh($form, h) {
  const { hide, show } = h
  const ns = '.admissaoCnh'

  function apply() {
    const cargo = $form.find('#params_cargo').val()
    const exige = cargoExigeCnh(cargo)

    const $secao = $form.find('#secao-cnh')
    const $upload = $form.find('#secao-cnh-upload')
    const $numero = $form.find('#params_cnh_numero')
    const $validade = $form.find('#params_cnh_validade')

    if (exige) {
      if ($secao.length) show($secao)
      if ($upload.length) show($upload)
      $numero.prop('required', true).attr('aria-required', 'true')
      $validade.prop('required', true).attr('aria-required', 'true')
    } else {
      if ($secao.length) hide($secao)
      if ($upload.length) hide($upload)
      $numero.prop('required', false).removeAttr('aria-required').val('')
      $validade.prop('required', false).removeAttr('aria-required').val('')
    }
  }

  $form.off(ns)
  $form.on(`change${ns}`, '#params_cargo', apply)

  return {
    apply,
    destroy() {
      $form.off(ns)
    }
  }
}
